enum ConnectorsNames {
  salesforce = 'salesforce',
  hubspot = 'hubspot',
  analytics = 'analytics',
  stripe = 'stripe',
  madMl = 'madMl',
}

export default ConnectorsNames;
